export default __webpack_public_path__ + "img/ec8dc6e5851c67bcb9fb42026ea02a80.svg";